import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AlertService, ChassisFormHandler, LoaderService, ToastService, PluginService, RouteService } from '@kaiser-software/chassis-core';
import { CommentModel } from '../../models/comment.model';
import { CommentService } from '../../services/comment.service';

@Component({
    selector: 'chassis-comments-comment-edit-page',
    templateUrl: './edit.page.html',
    styleUrls: ['./edit.page.scss'],
    providers: [AlertService, LoaderService]
})
export class CommentEditPage implements OnInit, OnDestroy {

    /**
     * The mode of the page that is being shown
     *
     * Available ptions:
     * create
     * edit
     * show (?)
     *
     * @type {string}
     */
    protected pageMode = 'edit';

    /**
     * The singular form of the model
     *
     * @type {string}
     */
    protected singular = 'comment';

    /**
     * The plural form of the model
     * @type {string}
     */
    protected plural = 'comments';

    /**
     * The title of the page
     *
     * @type {string}
     */
    protected title = this.pageMode + ' ' + this.singular;

    /**
     * The route prefix for the buttons
     *
     * @type {string}
     */
    protected routePrefix = this.plural;

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-comments-comment-edit';

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The CommentModel instance.
     *
     * @type {CommentModel}
     */
    public model: CommentModel;

    /**
     * The CommentService instance.
     */
    protected commentService: CommentService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ActivatedRoute instance.
     */
    protected activatedRoute: ActivatedRoute;

    /**
     * The PluginService instance.
     */
    protected pluginService: PluginService;

    /**
     * The ToastService instance.
     */
    protected toastService: ToastService;

    constructor(protected injector: Injector) {

        this.commentService = this.injector.get(CommentService);
        this.routeService   = this.injector.get(RouteService);
        this.activatedRoute = this.injector.get(ActivatedRoute);
        this.pluginService  = this.injector.get(PluginService);
        this.toastService   = this.injector.get(ToastService);

    }

    /*
     * Init
     */

    ngOnInit() {
        this.createForm();

        this.activatedRoute.params.subscribe(
            (params: Params) => {

                this.commentService.oneWith(params['comment'], []).subscribe((comment: CommentModel) => {

                    this.model      = comment;
                    this.form.model = this.model;

                });

            }, (error) => {

                this.toastService.error('error', error);
            }
        );

    }

    /**
     * Create the form.
     */
    protected createForm() {

        this.model = this.commentService.make();

        this.form = new ChassisFormHandler(this.injector, 'comment', this.model);

        // this.form.success((model) => {
        // });
        //
        // this.form.error((error) => {
        // });

    }

    /*
     * Cleanup
     */

    ngOnDestroy() {

        this.pluginService.slot(this.pluginPrefix + '-before').clear();
        this.pluginService.slot(this.pluginPrefix + '-after').clear();
        this.pluginService.slot(this.pluginPrefix + '-sidebar').clear();

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/pages/edit/edit.page.ts